import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop — Standard React Router 6 utility.
 *
 * On every pathname change, jump the window to (0, 0) instantly. This is
 * the expected UX when users click a nav item: the destination page shows
 * from the top, not mid-scroll from wherever the previous page was.
 *
 * Edge cases:
 *  - Hash-navigation (`/#stories`): skip the jump so the browser's native
 *    hash-scroll can take over.
 *  - Uses `behavior: 'instant'` — smooth scroll on route change feels laggy
 *    and disorienting (the page appears to "unravel" from the previous
 *    scroll-Y). Users expect a hard cut.
 *
 * Render as null — it's an effect-only side-mount.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) return; // let native hash-scroll handle it
    try {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    } catch {
      // Older engines don't accept the `behavior` option in the object form
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);
  return null;
}
